import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIcon } from '@angular/material/icon';
import { AuthService } from '@coin/shared/auth/data-access';
import { FaqDrill, FaqItem } from '@coin/shared/core/util-models';
import { FaqAnswerLevelComponent } from '../faq-answer-level/faq-answer-level.component';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'coin-siemens-energy-faq-inbetween-level',
  templateUrl: './faq-inbetween-level.component.html',
  styleUrls: ['./faq-inbetween-level.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatBadgeModule, FaqAnswerLevelComponent, NgStyle]
})
export class FaqInbetweenLevelComponent implements OnInit {
  private readonly authService = inject(AuthService);

  @Input() items: FaqItem;
  @Output() openFaq = new EventEmitter<FaqDrill>();

  private readonly isAuthenticated = signal(false);

  async ngOnInit(): Promise<void> {
    this.isAuthenticated.set(this.authService.isAuthenticated$.value);
  }

  public openFaqItem(content: FaqItem, level: number, moreWidth = false, title?: boolean, subtitle?: string): void {
    this.openFaq.emit({ content, level, moreWidth, title, subtitle });
  }

  public authRequired(item: FaqItem): boolean {
    return item.requiresAuthentication ? this.isAuthenticated() : true;
  }
}
